(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('HistoricoMapasCtrl', HistoricoMapasCtrl);

  HistoricoMapasCtrl.$inject = [
    '$scope',
    '$timeout',
    'LoadingService',
    'MapasInfestacaoService',
    '$q',
    'MessagesService',
    'OperacoesDadosService',
    'TiposOcorrenciasService',
    'CommonHTTPService',
    '$routeParams',
    '$route',
    '$filter',
    'NumberUtils',
    'HistoricoMapasService',
    '$uibModal',
    'PeriodSelectService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function HistoricoMapasCtrl($scope, $timeout, LoadingService, MapasInfestacaoService, $q, MessagesService,
    OperacoesDadosService, TiposOcorrenciasService, CommonHTTPService, $routeParams, $route, $filter, NumberUtils,
    HistoricoMapasService, $uibModal, PeriodSelectService) {
    const INTERACTIVE_MAP_TYPES = ['colheita', 'analise_solo'];
    const vm = this;
    let hasPage = true;
    let inProgress = false;
    let showingOnMap = [];

    //////////////////////////////////////////
    // Controller data
    vm.initialized = false;
    vm.filters = {
      page: 2,
      dataInicial: null,
      dataFinal: null
    };
    vm.keep = false;
    vm.safra = null;
    vm.glebas = [];
    vm.subtipos = [];
    vm.maps = [];
    vm.selected = [];
    vm.mapTypes = [];
    vm.legendaVisible = false;
    vm.bulkPrint = [];
    vm.chunkedBulkPrint = [];
    vm.loadingMapData = false;
    vm.periodo = {
      eventDates: [],
      periodo: ''
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.listMaps = listMaps;
    vm.setFilterAttribute = setFilterAttribute;
    vm.generateInfestationMaps = generateInfestationMaps;
    vm.toggleShowOnMap = toggleShowOnMap;
    vm.createNewMap = createNewMap;
    vm.inactivateMap = inactivateMap;
    vm.toggleFavorite = toggleFavorite;
    vm.editObservation = editObservation;
    vm.hasLegend = hasLegend;
    vm.canDelete = canDelete;
    vm.toggleRgbNdvi = toggleRgbNdvi;
    vm.getSelectedWithLegend = getSelectedWithLegend;
    vm.getLegendDescription = getLegendDescription;
    vm.stopPropagation = stopPropagation;
    vm.modalPragasVsAplicacoes = modalPragasVsAplicacoes;
    vm.modalNdvi = modalNdvi;
    vm.toggleBulkPrint = toggleBulkPrint;
    vm.clearBulkPrint = clearBulkPrint;
    vm.openPeriodsFilter = openPeriodsFilter;
    vm.setPeriodo = setPeriodo;
    vm.resetPeriodsFilter = resetPeriodsFilter;

    //////////////////////////////////////////
    // Function declarations

    function initializeVariables() {
      hasPage = true;
      inProgress = false;
      vm.maps = [];
      vm.filters.page = 1;
    }

    function resetVariables() {
      initializeVariables();
      vm.filters = {
        page: 1
      };
      vm.initialized = false;

      vm.glebas = $scope.$root.currentPropriedade.glebas || [];
      vm.selected = [];
      vm.showingOnMap = [];
      vm.activeLegend = null;
      vm.dataPragasVsAplicacoes = null;
    }

    function reset() {
      if (vm.keep) {
        return;
      }

      resetVariables();
    }

    function listMaps() {
      const hasFilterPage = hasPage && vm.filters && vm.filters.page;
      if (hasFilterPage && !inProgress) {
        LoadingService.showLoading();
        inProgress = true;

        HistoricoMapasService.listMaps(vm.filters).then((data) => {
          const dados = data.data || [];
          hasPage = hasNextPage(data.pages, vm.filters.page);

          dados.forEach(function(dado) {
            dado.imagem = OperacoesDadosService.getImagesObject([dado.imagem], true)[0];
          });

          atualizarMaps(dados);

          if (vm.filters.dataInicial && vm.filters.dataFinal) {
            if (moment(vm.filters.dataInicial).isSame(vm.filters.dataFinal)) {
              vm.selected = [];
              vm.maps.forEach(toggleShowOnMap);
            }
          }
        })
          .catch(errorGettingMaps)
          .finally(() => {
            inProgress = false;
            LoadingService.hideLoading();
          });
      }
    }

    function hasNextPage(pages, currentPage) {
      return (((pages || {}).pagination || {}).next || 0) > currentPage;
    }

    function atualizarMaps(dados) {
      if (dados.length) {
        vm.filters.page++;
        vm.maps = vm.maps.concat(dados);
        activateRouteHeatmaps();
      }
    }

    function activateRouteHeatmaps() {
      if ($routeParams.heatmaps) {
        /** @type number[] */
        const heatmaps = $routeParams.heatmaps.split(',').map((id) => +id);
        heatmaps.forEach((id) => {
          if (!vm.selected.includes(id)) {
            toggleShowOnMap(_.find(vm.maps, { id }));
          }
        });
      }
    }

    function errorGettingMaps(err) {
      console.error(err);
      MessagesService.alert('Não foi possível buscar a lista de Mapas.');
      inProgress = false;
      LoadingService.hideLoading();
    }

    function generateInfestationMaps() {
      LoadingService.showLoading();
      MapasInfestacaoService.generate()
        .then(LoadingService.hideLoading)
        .then(function() {
          initializeVariables();
          listMaps();
        })
        .catch(generateInfestationError);
    }

    function generateInfestationError(error) {
      const tryAgain = function() {
        return generateInfestationMaps();
      };

      console.error('Erro ao gerar mapas de infestação', error);
      if ((error || {}).status) {
        if (CommonHTTPService.isTimeout(error.status)) {
          return $timeout(function() {
            return tryAgain();
          }, 10000);
        } else if (CommonHTTPService.isLocked(error.status)) {
          if ($scope.tilesFlagTimeout) {
            return $timeout(function() {
              return tryAgain();
            }, 10000);
          }
          genericMessage(error.data);
        } else {
          genericMessage();
        }
      } else {
        genericMessage();
      }

      function genericMessage(message = null) {
        MessagesService.alert(message || 'Erro ao gerar os mapas de infestação');
      }
    }

    function getLegendPosition(map) {
      const width = angular.element('.map-data-legend').width();
      const minLeft = 6;
      const maxLeft = width + 4;
      const proportion = width / map.mapData.maxValue;
      const percentPosition = Math.max(map.mapData.mapPointValue - map.mapData.minValue, 0) * proportion / 100;
      return NumberUtils.clamp(NumberUtils.lerp(percentPosition, minLeft, maxLeft), minLeft, maxLeft);
    }

    function stopPropagation(event) {
      event.stopPropagation();
    }

    function modalPragasVsAplicacoes(map) {
      const data = {
        dataModelOptions: {
          gleba: map.gleba,
          safra: map.mapData.dados.safra,
          tipo: map.mapData.dados.tipo,
          grupo_insumo: map.mapData.dados.grupo_defensivos,
          modal: true
        },
        type: 'widget-pragas-vs-aplicacoes',
        title: `${map.mapData.dados.tipo.descricao} vs ${map.mapData.dados.grupo_defensivos.descricao}`
      };
      return $uibModal.open({
        templateUrl: 'views/widgets/widgetmodal.html',
        controller: 'WidgetModalCtrl',
        controllerAs: '$widget',
        size: 'lg',
        resolve: {
          data: () => data
        }
      });
    }

    function modalNdvi() {
      const mapas = getSelectedWithLegend().filter((map) => map.tipo === 'ndvi');
      if (mapas.length === 1) {
        MessagesService.alert('Selecione mais de um mapa para ver o comparativo.');
        return;
      }
      return $uibModal.open({
        templateUrl: 'views/propriedade/comparativo-ndvi.html',
        controller: 'ComparativoNdviCtrl',
        controllerAs: '$comparativo',
        windowClass: 'behind-loader',
        size: 'lg',
        resolve: {
          mapas: () => mapas
        }
      });
    }

    function loadDataMapa(map) {
      if (!map.mapData || !map.mapData.legend) {
        const id = map.id;
        vm.loadingMapData = true;
        HistoricoMapasService.get(id)
          .then((result) => {
            map.mapData = result;
            if ((map.mapData.dados || {}).legenda) {
              map.mapData.legend = map.mapData.dados.legenda;
              map.mapData.legend.splice(0, 1); // Remove primeiro elemento pois é a cor branca
              map.mapData.minValue = map.mapData.legend[0].min;
              map.mapData.maxValue = map.mapData.legend[map.mapData.legend.length - 1].min;
              map.mapData.gradient = `
                linear-gradient(to right, ${map.mapData.legend.map((item) => `rgba(${item.color_rgba})`).join(',')})
              `;
            }
          })
          .catch((error) => {
            console.error('Falha ao carregar dados do mapa', error);
            MessagesService.alert('Falha ao carregar dados do mapa');
          })
          .finally(() => vm.loadingMapData = false);
      }
    }

    // eslint-disable-next-line max-lines-per-function
    function toggleShowOnMap(map) {
      if (!map) {
        return;
      }
      const index = vm.selected.indexOf(map.id);

      if (index > -1) {
        vm.selected.splice(index, 1);
        showingOnMap.splice(index, 1);
      } else {
        showingOnMap = showingOnMap.filter((object, i) => {
          const include = object.gleba !== map.gleba.id || isInteractive(map, object);
          if (!include) {
            vm.selected.splice(i, 1);
          }
          return include;
        });

        showingOnMap.push({
          id: map.id,
          gleba: map.gleba.id,
          url: map.imagem.url
        });

        vm.selected.push(map.id);
        loadDataMapa(map);
      }

      const selectedWithLegend = getSelectedWithLegend();
      if (selectedWithLegend.length) {
        vm.activeLegend = selectedWithLegend[selectedWithLegend.length - 1];
      } else {
        vm.activeLegend = null;
      }

      propagateImages();
    }

    function isInteractive(map, object) {
      return INTERACTIVE_MAP_TYPES.includes(map.tipo) &&
        INTERACTIVE_MAP_TYPES.includes(_.find(vm.maps, { id: object.id }).tipo);
    }

    function propagateImages() {
      $scope.$emit('setImageOverlays', showingOnMap.slice());
      /** @type Array */
      let activeHeatmaps = vm.maps.filter((map) => _.find(showingOnMap, { id: map.id }));
      if (!activeHeatmaps.length) {
        activeHeatmaps = null;
      }
      $route.updateParams({
        heatmaps: (activeHeatmaps || []).map((map) => map.id).join() || null
      });
      $scope.$emit('setActiveHeatmaps', { heatmaps: activeHeatmaps, mapType: 'date' });
    }

    /**
     * Sets filter attribute based on selected option
     *
     * @param {string} attribute attribute to be set
     * @param {any} object object with value
     * @param {Event} event click event
     */
    function setFilterAttribute(attribute, object, event = null) {
      if (event) {
        event.preventDefault();
      }
      initializeVariables();
      vm.filters[attribute] = object;
      vm.listMaps();
    }

    function createNewMap() {
      $scope.$emit('activateSidebar', 'painelCriarMapa');
    }

    function inactivateDialog(map) {
      if (map.tipo === 'ndvi') {
        const buttons = [
          { label: 'Cancelar', className: 'btn-default' },
          { label: 'Todos da Cena', inactivate_siblings: true },
          { label: 'Somente Este' }
        ];

        return MessagesService.dialogCustom(
          'Inativar mapa',
          'Arquivar somente este mapa ou toda a cena está comprometida com nuvens e deseja arquivar todos deste dia?',
          buttons
        );
      }
      return MessagesService.confirm('Deseja inativar este mapa?');
    }

    function inactivationSuccess(result) {
      if (result === 'skip') {
        LoadingService.hideLoading();
        return;
      }
      MessagesService.alert('Mapa inativado com sucesso!');
      $route.updateParams({
        heatmaps: null
      });
      $scope.$emit('setImageOverlays', []);
      $scope.$emit('setActiveHeatmaps', []);
      reset();
      vm.listMaps();
      vm.initialized = true;
    }

    function inactivateMap($event, map) {
      stopPropagation($event);

      inactivateDialog(map)
        .then((button) => {
          LoadingService.showLoading();
          button = button || {};
          if (button.label === 'Cancelar') {
            return 'skip';
          }
          return HistoricoMapasService.inactivateMap(map.id, {
            inactivate_siblings: button.inactivate_siblings
          });
        })
        .then(inactivationSuccess)
        .catch((error) => {
          // Se cancelar a confirmação, será rejeitado sem erro
          // Se houver erro, é de servidor
          if (error) {
            console.error('Erro ao inativar mapa', error);
            MessagesService.alert('Não foi possível inativar o mapa selecionado.');
          }
        });
    }

    function toggleFavorite($event, map) {
      stopPropagation($event);

      LoadingService.showLoading();

      return HistoricoMapasService
        .update(map.id, { st_favorite: !map.favorite ? 'S' : 'N' })
        .then(() => {
          map.favorite = !map.favorite;
          map.st_favorite = map.favorite ? 'S' : 'N';
        })
        .catch((error) => {
          console.error('Erro ao atualizar mapa', error);
          MessagesService.alert('Não foi possível atualizar o mapa selecionado.');
        })
        .finally(LoadingService.hideLoading);
    }

    function editObservation($event, map) {
      stopPropagation($event);
      MessagesService
        .prompt('Observação', { value: map.observation, inputType: 'textarea' })
        .then((result) => {
          LoadingService.showLoading();

          return HistoricoMapasService
            .update(map.id, { observation: result })
            .then(() => map.observation = result)
            .catch((error) => {
              console.error('Erro ao atualizar mapa', error);
              MessagesService.alert('Não foi possível atualizar o mapa selecionado.');
            })
            .finally(LoadingService.hideLoading);
        })
        .catch((error) => {
          // Se cancelar a confirmação, será rejeitado sem erro
          // Se houver erro, é de servidor
          if (error) {
            console.error('Erro ao editar observação do mapa', error);
            MessagesService.alert('Não foi possível editar observação do mapa.');
          }
        });
    }

    function getSelectedWithLegend() {
      return vm.maps
        .filter((map) => vm.selected.includes(map.id) && (INTERACTIVE_MAP_TYPES.includes(map.tipo) || map.automatic));
    }

    function getLegendDescription(map) {
      if (map) {
        return `${$filter('date')(map.data, 'dd/MM')} ${map.gleba.descricao} ${map.descricao}`;
      }
    }

    function hasLegend(map) {
      if (map) {
        return check(map);
      }
      return vm.maps.some(check);

      function check(mapToCheck) {
        return mapToCheck.mapData && mapToCheck.mapData.legend && vm.selected.includes(mapToCheck.id);
      }
    }

    function canDelete(map) {
      return map.tipo !== 'pragas' && $scope.$root.permissions.mapas.canManage;
    }

    function toggleRgbNdvi(map) {
      if (map.visibleRgbNdvi) {
        $scope.$emit('singleImageOverlay');
        return;
      }

      const url = map.mapData.dados.url_rgb;
      const bounds = L.latLngBounds(
        map.mapData.dados.bounds_scene.lower_left,
        map.mapData.dados.bounds_scene.upper_right
      );

      const load = () => {
        LoadingService.hideLoading();
        $scope.$emit('singleImageOverlay', {
          url,
          bounds
        });
        $scope.$apply();
      };

      LoadingService.showLoading();
      // Imagem criada dinamicamente para poder ter loader
      const imageLoader = document.createElement('img');
      imageLoader.src = url;
      imageLoader.onload = load;
      imageLoader.onerror = load;
    }

    function toggleBulkPrint(map) {
      if (vm.bulkPrint.includes(map)) {
        return vm.bulkPrint.splice(vm.bulkPrint.indexOf(map), 1);
      }
      vm.bulkPrint.push(map);
      vm.bulkPrint = _.sortBy(vm.bulkPrint, (item) => new Date(item.data));
      getBulkPrintMaps();
      loadDataMapa(map);
    }

    function getBulkPrintMaps() {
      vm.chunkedBulkPrint = _(vm.bulkPrint)
        .chunk(6)
        .value();
    }

    function clearBulkPrint() {
      vm.bulkPrint = [];
      vm.chunkedBulkPrint = [];
    }

    function clearMap() {
      if (!$routeParams.heatmaps) {
        $scope.$emit('setImageOverlays', []);
        $scope.$emit('setActiveHeatmaps', []);
        $scope.$emit('clearPolylines');
        $scope.$emit('clearMarkers');

        setTimeout(() => {
          $route.updateParams({
            heatmaps: null
          });
        }, 0);
      }
    }

    function openPeriodsFilter(event) {
      preventDefault(event);
      PeriodSelectService.openPeriodSelection(vm.periodo, vm.filters)
        .then(function() {
          vm.setPeriodo();
        });
    }

    function setPeriodo(periodo, event) {
      preventDefault(event);
      initializeVariables();
      if (periodo) {
        vm.filters.dataInicial = periodo.dataInicial;
        vm.filters.dataFinal = periodo.dataFinal;
        vm.periodo.periodo = periodo.descricao;
      }
      vm.listMaps();
    }

    function resetPeriodsFilter() {
      vm.filters.dataInicial = null;
      vm.filters.dataFinal = null;
      vm.periodo = {
        eventDates: [],
        periodo: ''
      };
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$root.initialize.then(() => {
      if (!$scope.$root.permissions.ocorrencia.canRead && !$scope.$root.permissions.mapas.canManage) {
        MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
        $route.updateParams({ sidebar: null });
        return [{}, {}];
      }

      $scope.$emit('clearHeatMap');
      LoadingService.showLoading();
      reset();
      clearMap();

      const selectedGleba = $routeParams.gleba || $routeParams.activeGleba;
      const selectedDate = $routeParams.date;
      if (selectedGleba) {
        setFilterAttribute('gleba', $scope.$root.currentPropriedade.glebas.find(({ id }) => id === +selectedGleba));
      }

      if (selectedDate) {
        setPeriodo({
          dataInicial: selectedDate,
          dataFinal: selectedDate,
          descricao: moment(selectedDate).format('DD/MM/YYYY')
        });
      }

      const promises = [
        HistoricoMapasService.listTypes(),
        TiposOcorrenciasService.listWithInfestation()
      ];

      return $q.all(promises);
    }).then(([mapTypes, subtipos]) => {
      vm.mapTypes = mapTypes.data || [];
      vm.subtipos = subtipos.data || [];
      vm.initialized = true;
    })
      .catch((error) => {
        console.error(error);
        MessagesService.alert('Não foi possível buscar informações.');
      })
      .finally(vm.listMaps);

    $scope.$on('$routeUpdate', () => {
      if (!$routeParams.heatmaps) {
        vm.selected = [];
        showingOnMap = [];
      }
    });

    $scope.$root.$on('clickMapLayer', (_event, dataEvent) => {
      $scope.$apply(() => {
        const latitudeAccuracy = NumberUtils.truncate(dataEvent.latlng.lat, 4);
        const longitudeAccuracy = NumberUtils.truncate(dataEvent.latlng.lng, 4);

        const latitude = NumberUtils.truncate(dataEvent.latlng.lat, 3);
        const longitude = NumberUtils.truncate(dataEvent.latlng.lng, 3);

        vm.maps.forEach((map) => {
          if (map.mapData && vm.selected.includes(map.id)) {
            try {
              const value = map.mapData.indexedPoints[longitude] && map.mapData.indexedPoints[longitude][latitude];
              const valueAccuracy = map.mapData.indexedPoints[longitudeAccuracy] &&
                map.mapData.indexedPoints[longitudeAccuracy][latitudeAccuracy];
              map.mapData.mapPointValue = (valueAccuracy || value)[map.mapData.field];
              map.mapData.legendPosition = getLegendPosition(map);
            } catch (error) {
              /* Não achou ponto no mapa */
              map.mapPointValue = null;
            }
          }
        });
      });
    });

    $scope.$on('$destroy', function() {
      $scope.$emit('singleImageOverlay');
    });
  }
}());
